export const CLEVER_TAP_EVENT = {
    APP_STARTED: 'app_started',
    APP_EXITED: 'app_exited',
    USER_LOGIN: 'user_login',
    USER_SIGNUP: 'user_signup',
    OUTLET_VIEWED: 'outlet_viewed',
    OUTLET_EXITED: 'outlet_exited',
    ITEM_ADDED_CART: 'item_added_cart',
    ITEM_REMOVED_CART: 'item_removed_cart',
    CART_CLEARED: 'cart_cleared',
    PROFILE_CHANGE: 'profile_change',
    USED_REFERRAL: 'used_referral',
    MENU_SEARCH: 'menu_search',
    EXPLORE_SEARCH: 'explore_search',
    USER_LOGOUT: 'user_logout',
    FOOD_PREFERENCE: 'food_preference',
    INVITED_USER_ATTEMPT: 'invited_user_attempt',
    SHARED_OUTLET: 'shared_outlet',
    PAYMENT_INITIATED: 'payment_initiated',
    PAYMENT_CANCELED: 'payment_canceled',
    PAYMENT_SUCCESS: 'payment_success',
    PAYMENT_FAILED: 'payment_failed',
    UNABLE_TO_CHECKOUT: 'unable_to_checkout',
    COUPON_APPLIED: 'coupon_applied',
    COUPON_REMOVED: 'coupon_removed',
    ORDER_TRACKING: 'order_tracking',
    EVENT_ISSUE: 'event_issue',
    USER_LOCATION: 'user_location',
    SEE_ALL_RESTAURANTS: 'see_all_restaurants',
    PROMO_CLICK: 'promo_click',
    CHANGED: 'Charged',
    TOP_BANNER_CLICK: 'top_banner_click',
    TOP_BANNER_IMPRESSION: 'top_banner_impression',

    
    SEND_OTP_TO_USER: 'send_otp_to_user',
    USER_CHANGE_LOCATION: 'user_change_location',
    COUPON_PAGE_VISITED: 'coupon_page_visited',
    CHECKOUT_CLICKED: 'checkout_clicked',
    CART_CLICKED: 'cart_clicked',
    PAY_CLICKED: 'pay_clicked',
    LETS_EXPLORE: 'lets_explore',
    VEG_TOGGLED: 'veg_toggled',
    EGG_TOGGLED: 'egg_toggled',
    CHANGE_OUTLET: 'change_outlet',
    PROFILE_CLICKED: 'profile_clicked',
    MANAGE_ADDRESSES: 'manage_addresses',
    USER_WALLET: 'user_wallet',
    ORDER_HISTORY: 'order_history',
    MY_REWARDS :'my_rewards',
    CATEGORY_CLICKED: 'category_clicked',
    SUBCATEGORY_CLICKED: 'subcategory_clicked',
    SEARCH_MENUITEM: 'search_menuitem',
    USER_SIGNUP_EVENT: 'user_signup_event',
    ALLOW_BLOCK_NOTIFICATION: 'allow_block_notification',
    PUSH_NOTIFICATION_CLICKED: 'push_notification_clicked',
    SEARCH_FOR_RESTAURANTS_OR_FOOD: 'search_for_restaurants_or_food',
    APP_FOREGROUND: 'app_foreground',
    APP_BACKGROUND: 'app_background',
    INVITE_CLICKED: 'invite_clicked',
    UPI_APP_CLICKED : 'upi_app_clicked',
    DEEP_LINK_CLICKED: 'deep_link_clicked',
    APP_ERROR:'app_error',

}